import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';

const ProdWastageRow = (props) => {
    const { formObject, index, rowKey } = props;


    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn30">
                <span>{index}</span>
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
            </li>
            <li className="uiColumnCenter uiColumn150">
                <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                    action={{ paramName: "actualItem", actionId: "show" }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyIssued" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyWasted" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyDamaged" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyLost" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "percAllowance" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAllowanced" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyDiff" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "percLoss" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "percDiff" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "wastageValue" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "deduction" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} />
            </li>
        </ul>
    )
}

export default ProdWastageRow
